import { styled } from '@linaria/react';
import { RectangleSkeleton, CircleSkeleton } from '@fe-common-ui/Skeleton';

const Headline = styled.div`
  display: flex;
  color: #54b5c6;
  align-items: center;
  margin: '0px';
`;

const Time = styled.div`
  margin-left: 8px;
`;

const Fire = styled.div`
  margin-left: 12px;
`;

const Content = styled.div`
  flex: 1;
  margin-left: 8px;
`;

const TimelineSkeleton = () => {
  return (
    <Headline>
      <CircleSkeleton width={12} height={12} />
      <Time>
        <RectangleSkeleton width={46} height={16} />
      </Time>
      <Fire>
        <CircleSkeleton width={22} height={22} />
      </Fire>
      <Content>
        <RectangleSkeleton width={300} height={20} style={{ minWidth: '100%' }} />
      </Content>
    </Headline>
  );
};

export default TimelineSkeleton;
